// import React, { useEffect, useState } from "react";
// import {
//   Box,
//   Modal,
//   Button,
//   FormControlLabel,
//   IconButton,
//   Switch,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Grid,
//   Typography,
// } from "@mui/material";
// import DeleteIcon from "@mui/icons-material/Delete";
// import EditIcon from "@mui/icons-material/Edit";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import Admin from "../Dashboard";
// import DeleteSchoolModal from "../School/DeleteSchoolModal";
// import CloseIcon from "@mui/icons-material/Close";
// import dayjs from "dayjs";


// const InfoItem = ({ label, value }) => (
//   <Grid item xs={12} sm={6}>
//     <Typography variant="subtitle2" fontWeight={600}>
//       {label}
//     </Typography>
//     <Typography variant="body2" sx={{ mb: 2 }}>
//       {value || "-"}
//     </Typography>
//   </Grid>
// );

// const ConsultationModal = ({ open, onClose, application }) => {
//   if (!application) return null;
//   const data = application.data || {};

//   return (
//     <Modal open={open} onClose={onClose}>
//       <Box
//         sx={{
//           position: "absolute",
//           top: "50%",
//           left: "50%",
//           transform: "translate(-50%, -50%)",
//           width: "90%",
//           maxWidth: 700,
//           bgcolor: "background.paper",
//           borderRadius: "10px",
//           boxShadow: 24,
//           p: 3,
//           maxHeight: "90vh",
//           overflowY: "auto",
//         }}
//       >
//         <Box display="flex" justifyContent="space-between">
//           <Typography variant="h6" fontWeight={700}>
//             Consultation Details
//           </Typography>
//           <IconButton onClick={onClose}>
//             <CloseIcon />
//           </IconButton>
//         </Box>

//         <Grid container spacing={2} mt={2}>
//           <InfoItem label="Name" value={data?.name || '-'} />
//                     <InfoItem label="Gender" value={data?.gender || '-'} />
//                     <InfoItem label="Nationality" value={data?.nationality || '-'} />
//                      <InfoItem
//                       label="DOB"
//                       value={data.dob ? dayjs(data.dob).format("DD/MM/YYYY") : "-"}
//                     />
//                     <InfoItem label="Email" value={data?.email || '-'} />
//                     <InfoItem label="Contact No" value={`+${data?.phone || '-'}`} />
//                     <InfoItem label="Line" value={`${data?.line || '-'}`} />
//                     <InfoItem label="Whatsapp" value={`${data?.whatsapp || '-'}`} />
//                     <InfoItem label="Wechat" value={`${data?.wechat || '-'}`} />
//                     <InfoItem label="Kakaotalk" value={`${data?.kakaotalk || '-'}`} />
//                     <InfoItem label="Zalo" value={`${data?.zolo || '-'}`} />
//                     <InfoItem label="Registration By" value={`${data?.registrationBy || '-'}`} />
//                     <InfoItem label="Highest Education Level" value={`${data?.highestEducationLevel || '-'}`} />
//                     <InfoItem label="Current School" value={`${data?.currentSchool || '-'}`} />
//                     <InfoItem label="Current Grade" value={`${data?.currentGrade || '-'}`} />
//                     <InfoItem label="Desired Program of Study" value={`${data?.desiredProgramOfStudy || '-'}`} />
          
          
                    
                    
          
                   
          
//                     <InfoItem
//                       label="Preferred Date"
//                       value={
//                         data.preferredDate
//                           ? dayjs(data.preferredDate).format("DD/MM/YYYY")
//                           : "-"
//                       }
//                     />
          
//                     <InfoItem label="Preferred Time Slot" value={data?.preferredTimeSlot || '-'} />
//                     <InfoItem label="Application Type" value={data?.applicationType || '-'} />
//                     <InfoItem label="Preferred School" value={data?.preferredSchool || '-'} />

//           <Grid item xs={12}>
//             <Typography variant="subtitle2" fontWeight={600}>
//               Comments
//             </Typography>
//             <Typography variant="body2">{data.comments || "-"}</Typography>
//           </Grid>
//         </Grid>
//       </Box>
//     </Modal>
//   );
// };


// export default function ConsultationList() {
//   const navigate = useNavigate();

//   const [list, setList] = useState([]);
//   const [open, setOpen] = useState(false);
//   const [deleteItem, setDeleteItem] = useState({});
  
//   const [openModal, setOpenModal] = useState(false);
// const [selectedApp, setSelectedApp] = useState(null);

//   // Pagination
//   const [page, setPage] = useState(1);
//   const limit = 10; // per page
//   const [totalPages, setTotalPages] = useState(1);

//   // Fetch consultations
//   const getConsultations = async () => {
//     try {
//       const response = await axios.get(
//         `${process.env.REACT_APP_BASE_URL}/get-consultation-applications?page=${page}&limit=${limit}`
//       );

//       if (response.status === 200) {
//         setList(response.data.data);

//         setTotalPages(response.data.pagination.pages || 1);
//       }
//     } catch (error) {
//       console.log("Error fetching consultations", error);
//     }
//   };

//   useEffect(() => {
//     getConsultations();
//   }, [page]);

//   // Delete
//   const handleDelete = async (id) => {
//     try {
//       const res = await axios.delete(
//         `${process.env.REACT_APP_BASE_URL}/delete-consultation-application/${id}`
//       );
//       if (res.status === 200) {
//         setOpen(false);
//         getConsultations();
//       }
//     } catch (error) {
//       console.log(error);
//     }
//   };

//   // Edit
//   const handleEdit = (id) => navigate(`/admin/editConsultation/${id}`);

//   // Status Change
//   const handleSwitchChange = async (id, currentValue) => {
//     try {
//       await axios.put(`${process.env.REACT_APP_BASE_URL}/consultation/status`, {
//         id,
//         status: !currentValue,
//       });
//       getConsultations();
//     } catch (error) {
//       console.log("Error updating status", error);
//     }
//   };

//   const formatCategory = (value) => {
//   if (!value) return "-";
//   return value
//     .split("-")
//     .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
//     .join(" ");
// };

//   return (
//     <Admin>
//       <DeleteSchoolModal
//         open={open}
//         onClose={() => setOpen(false)}
//         school={deleteItem.title}
//         handleDelete={handleDelete}
//         deleteSchoolId={deleteItem.id}
//       />

//       {/* <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
//         <Button
//           variant="contained"
//           sx={{ bgcolor: "#177D84" }}
//           onClick={() => navigate("/admin/addConsultation")}
//         >
//           Add
//         </Button>
//       </Box> */}

//       <TableContainer component={Paper}>
//         <Table>
//           <TableHead>
//             <TableRow>
//               <TableCell>Sno</TableCell>
//               <TableCell>Name</TableCell>
//               <TableCell>Email</TableCell>
//               <TableCell>Phone</TableCell>
//               <TableCell>Category</TableCell>
//               <TableCell>Activity Name</TableCell>
//               <TableCell>Actions</TableCell>
//               {/* <TableCell>Status</TableCell> */}
//             </TableRow>
//           </TableHead>

//           <TableBody>
//             {list.map((item, index) => (
//               <TableRow key={item._id}>
//                 <TableCell>{(page - 1) * limit + index + 1}</TableCell>
//                 <TableCell>{item?.data?.name || "-"}</TableCell>
//                 <TableCell>{item?.data?.email || "-"}</TableCell>
//                 <TableCell>{`+${item?.data?.phone}` || "-"}</TableCell>
//                 <TableCell>{`${item?.data?.applicationType}` || "-"}</TableCell>
//                 <TableCell>{`${item?.data?.application_name || "-"}` || "-"}</TableCell>
                

//                 {/* Delete */}
//                 <TableCell>
//                   <IconButton
//     onClick={() => {
//       setSelectedApp(item);
//       setOpenModal(true);
//     }}
//     title="View Details"
//   >
//     👁️
//   </IconButton>
//                   <IconButton
//                     onClick={() => {
//                       setDeleteItem({
//                         title: item.data?.title?.en,
//                         id: item._id,
//                       });
//                       setOpen(true);
//                     }}
//                   >
//                     <DeleteIcon />
//                   </IconButton>

//                   {/* Edit */}
//                   {/* <IconButton onClick={() => handleEdit(item._id)}>
//                     <EditIcon />
//                   </IconButton> */}
//                 </TableCell>

//                 {/* Toggle Status */}
//                 {/* <TableCell>
//                   <FormControlLabel
//                     control={
//                       <Switch
//                         checked={item.isShow}
//                         onChange={() =>
//                           handleSwitchChange(item._id, item.isShow)
//                         }
//                       />
//                     }
//                   />
//                 </TableCell> */}
//               </TableRow>
//             ))}
//           </TableBody>
//         </Table>
//       </TableContainer>

//       <ConsultationModal
//   open={openModal}
//   onClose={() => setOpenModal(false)}
//   application={selectedApp}
// />

//       {/* Pagination */}
//       <Box sx={{ display: "flex", justifyContent: "center", mt: 2, gap: 2 }}>
//         <Button
//           variant="outlined"
//           disabled={page === 1}
//           onClick={() => setPage(page - 1)}
//         >
//           Prev
//         </Button>
//         <Button
//           variant="outlined"
//           disabled={page === totalPages}
//           onClick={() => setPage(page + 1)}
//         >
//           Next
//         </Button>
//       </Box>
//     </Admin>
//   );
// }

import React, { useEffect, useState } from "react";
import {
  Box,
  Modal,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Grid,
  Typography,
  Card,
  CardContent,
  InputAdornment,
  Chip
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import SearchIcon from "@mui/icons-material/Search";
import FilterListIcon from "@mui/icons-material/FilterList";
import ClearIcon from "@mui/icons-material/Clear";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Admin from "../Dashboard";
import DeleteSchoolModal from "../School/DeleteSchoolModal";
import CloseIcon from "@mui/icons-material/Close";
import dayjs from "dayjs";

const InfoItem = ({ label, value }) => (
  <Grid item xs={12} sm={6}>
    <Typography variant="subtitle2" fontWeight={600}>
      {label}
    </Typography>
    <Typography variant="body2" sx={{ mb: 2,wordBreak: "break-word",
        overflowWrap: "anywhere",
        whiteSpace: "normal" }}>
      {value || "-"}
    </Typography>
  </Grid>
);

const ConsultationModal = ({ open, onClose, application }) => {
  if (!application) return null;
  const data = application.data || {};

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "90%",
          maxWidth: 700,
          bgcolor: "background.paper",
          borderRadius: "10px",
          boxShadow: 24,
          p: 3,
          maxHeight: "90vh",
          overflowY: "auto",
        }}
      >
        <Box display="flex" justifyContent="space-between">
          <Typography variant="h6" fontWeight={700}>
            Consultation Details
          </Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>

        <Grid container spacing={2} mt={2}>
          <InfoItem label="Name" value={data?.name || '-'} />
          <InfoItem label="Gender" value={data?.gender || '-'} />
          <InfoItem label="Nationality" value={data?.nationality || '-'} />
          <InfoItem
            label="DOB"
            value={data.dob ? dayjs(data.dob).format("DD/MM/YYYY") : "-"}
          />
          <InfoItem label="Email" value={data?.email || '-'} />
          <InfoItem label="Contact No" value={`+${data?.phone || '-'}`} />
          <InfoItem label="Line" value={`${data?.line || '-'}`} />
          <InfoItem label="Whatsapp" value={`${data?.whatsapp || '-'}`} />
          <InfoItem label="Wechat" value={`${data?.wechat || '-'}`} />
          <InfoItem label="Kakaotalk" value={`${data?.kakaotalk || '-'}`} />
          <InfoItem label="Zalo" value={`${data?.zolo || '-'}`} />
          <InfoItem label="Registration By" value={`${data?.registrationBy || '-'}`} />
          <InfoItem label="Highest Education Level" value={`${data?.highestEducationLevel || '-'}`} />
          <InfoItem label="Current School" value={`${data?.currentSchool || '-'}`} />
          <InfoItem label="Current Grade" value={`${data?.currentGrade || '-'}`} />
          <InfoItem label="Desired Program of Study" value={`${data?.desiredProgramOfStudy || '-'}`} />
          
          <InfoItem
            label="Preferred Date"
            value={
              data.preferredDate
                ? dayjs(data.preferredDate).format("DD/MM/YYYY")
                : "-"
            }
          />
          
          <InfoItem label="Preferred Time Slot" value={data?.preferredTimeSlot || '-'} />
          <InfoItem label="Application Type" value={data?.applicationType || '-'} />
          <InfoItem label="Preferred School" value={data?.preferredSchool || '-'} />

          <Grid item xs={12}>
            <Typography variant="subtitle2" fontWeight={600}>
              Comments
            </Typography>
            <Typography variant="body2">{data.comments || "-"}</Typography>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};

export default function ConsultationList() {
  const navigate = useNavigate();

  const [list, setList] = useState([]);
  const [open, setOpen] = useState(false);
  const [deleteItem, setDeleteItem] = useState({});
  const [openModal, setOpenModal] = useState(false);
  const [selectedApp, setSelectedApp] = useState(null);
  const [showFilters, setShowFilters] = useState(true);
  const [refreshApi, setRefreshApi] = useState(1);

  // Filters state
  const [filters, setFilters] = useState({
    search: "",
    applicationType: "",
    fromDate: "",
    toDate: ""
  });

  // Pagination
  const [page, setPage] = useState(1);
  const limit = 10;
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);

  // Application types for dropdown
  const applicationTypes = [
    "Online Consultation",
    "School Based Tour", 
    "Offline Consultation",
    "Online Info Session",
    "Offline Info Session"
  ];

  // Fetch consultations with filters
  const getConsultations = async () => {
    try {
      // Build query parameters
      const params = new URLSearchParams({
        page: page,
        limit: limit
      });

      // Add filters if they exist
      if (filters.search) params.append('search', filters.search);
      if (filters.applicationType) params.append('applicationType', filters.applicationType);
      if (filters.fromDate) params.append('fromDate', filters.fromDate);
      if (filters.toDate) params.append('toDate', filters.toDate);

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/get-consultation-applications?${params.toString()}`
      );

      if (response.status === 200) {
        setList(response.data.data);
        setTotalPages(response.data.pagination.pages || 1);
        setTotalItems(response.data.pagination.total || 0);
      }
    } catch (error) {
      console.log("Error fetching consultations", error);
    }
  };

  useEffect(() => {
    getConsultations();
  }, [page]);

  // Apply filters
  const handleApplyFilters = () => {
    setPage(1); // Reset to first page when applying filters
    getConsultations();
  };

  // Clear all filters
  const handleClearFilters = () => {
    setFilters({
      search: "",
      applicationType: "",
      fromDate: "",
      toDate: ""
    });
    setPage(1);
    setRefreshApi(prev => prev + 1); // Trigger useEffect to refetch data
  };

  useEffect(() => {
    getConsultations();
  }, [refreshApi]);

  // Delete
  const handleDelete = async (id) => {
    try {
      const res = await axios.delete(
        `${process.env.REACT_APP_BASE_URL}/delete-consultation-application/${id}`
      );
      if (res.status === 200) {
        setOpen(false);
        getConsultations();
      }
    } catch (error) {
      console.log(error);
    }
  };

  // Edit
  const handleEdit = (id) => navigate(`/admin/editConsultation/${id}`);

  // Handle search input change with debounce
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setFilters(prev => ({ ...prev, search: value }));
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleApplyFilters();
    }
  };

  const formatCategory = (value) => {
    if (!value) return "-";
    return value
      .split("-")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  // Check if any filter is active
  const isAnyFilterActive = () => {
    return filters.search || filters.applicationType || filters.fromDate || filters.toDate;
  };

  // Get active filter count
  const getActiveFilterCount = () => {
    let count = 0;
    if (filters.search) count++;
    if (filters.applicationType) count++;
    if (filters.fromDate) count++;
    if (filters.toDate) count++;
    return count;
  };

  return (
    <Admin>
      <DeleteSchoolModal
        open={open}
        onClose={() => setOpen(false)}
        school={deleteItem.title}
        handleDelete={handleDelete}
        deleteSchoolId={deleteItem.id}
      />

      <Box sx={{ mb: 3 }}>
        <Card>
          <CardContent>
            {/* Search Bar */}
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <TextField
                fullWidth
                placeholder="Search by name, email, phone, application name or type..."
                value={filters.search}
                onChange={handleSearchChange}
                onKeyPress={handleKeyPress}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                  endAdornment: filters.search && (
                    <InputAdornment position="end">
                      <IconButton
                        size="small"
                        onClick={() => {
                          setFilters(prev => ({ ...prev, search: "" }));
                          handleApplyFilters();
                        }}
                      >
                        <ClearIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              
              <IconButton 
                onClick={() => setShowFilters(!showFilters)}
                sx={{ ml: 2 }}
                color={showFilters || isAnyFilterActive() ? "primary" : "default"}
              >
                <FilterListIcon />
                {getActiveFilterCount() > 0 && (
                  <Chip 
                    label={getActiveFilterCount()} 

                    size="small" 
                    sx={{ 
                      position: 'absolute', 
                      top: 2, 
                      right: 0,
                      height: 16,
                      minWidth: 16,
                      fontSize: '0.6rem',
                      backgroundColor: 'blue',
                      color: 'white',
                      pointerEvents: 'none'
                    }} 
                  />
                )}
              </IconButton>
            </Box>

            {/* Advanced Filters */}
            {showFilters && (
              <Box sx={{ mt: 2, p: 2, bgcolor: 'background.default', borderRadius: 1 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6} md={3}>
                    <FormControl fullWidth size="small">
                      <Typography>Application Type</Typography>
                      <Select
                        value={filters.applicationType}
                        // label="Application Type"
                        onChange={(e) => setFilters(prev => ({ ...prev, applicationType: e.target.value }))}
                      >
                        <MenuItem value="">All Types</MenuItem>
                        {applicationTypes.map((type) => (
                          <MenuItem key={type} value={type}>{type}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  
                  <Grid item xs={12} sm={6} md={3}>
                    <Typography>From Date</Typography>
                    <TextField
                      fullWidth
                      type="date"
                      // label="From Date"
                      value={filters.fromDate}
                      onChange={(e) => setFilters(prev => ({ ...prev, fromDate: e.target.value }))}
                      size="small"
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  
                  <Grid item xs={12} sm={6} md={3}>
                    <Typography>To Date</Typography>
                    <TextField
                      fullWidth
                      type="date"
                      // label="To Date"
                      value={filters.toDate}
                      onChange={(e) => setFilters(prev => ({ ...prev, toDate: e.target.value }))}
                      size="small"
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  
                  <Grid item xs={12} sm={6} md={3} sx={{ display: 'flex', gap: 1, alignItems: 'center', mt : 3 }}>
                    <Button 
                      variant="contained" 
                      onClick={handleApplyFilters}
                      fullWidth
                    >
                      Apply Filters
                    </Button>
                    <Button 
                      variant="outlined" 
                      onClick={handleClearFilters}
                      disabled={!isAnyFilterActive()}
                    >
                      Clear
                    </Button>
                  </Grid>
                </Grid>

                {/* Active Filters Display */}
                {isAnyFilterActive() && (
                  <Box sx={{ mt: 2, display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                    <Typography variant="body2" color="textSecondary">
                      Active Filters:
                    </Typography>
                    {filters.search && (
                      <Chip 
                        label={`Search: ${filters.search}`}
                        size="small"
                        onDelete={() => {
                          setFilters(prev => ({ ...prev, search: "" }));
                          handleApplyFilters();
                        }}
                      />
                    )}
                    {filters.applicationType && (
                      <Chip 
                        label={`Type: ${filters.applicationType}`}
                        size="small"
                        onDelete={() => {
                          setFilters(prev => ({ ...prev, applicationType: "" }));
                          handleApplyFilters();
                        }}
                      />
                    )}
                    {filters.fromDate && (
                      <Chip 
                        label={`From: ${filters.fromDate}`}
                        size="small"
                        onDelete={() => {
                          setFilters(prev => ({ ...prev, fromDate: "" }));
                          handleApplyFilters();
                        }}
                      />
                    )}
                    {filters.toDate && (
                      <Chip 
                        label={`To: ${filters.toDate}`}
                        size="small"
                        onDelete={() => {
                          setFilters(prev => ({ ...prev, toDate: "" }));
                          handleApplyFilters();
                        }}
                      />
                    )}
                  </Box>
                )}
              </Box>
            )}
          </CardContent>
        </Card>
      </Box>

      {/* Results Count */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="body2" color="textSecondary">
          Total: {totalItems} applications
        </Typography>
        <Typography variant="body2" color="textSecondary">
          Page {page} of {totalPages}
        </Typography>
      </Box>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Sno</TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Phone</TableCell>
              <TableCell>Category</TableCell>
              <TableCell>Activity Name</TableCell>
              <TableCell>Date</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {list.length > 0 ? (
              list.map((item, index) => (
                <TableRow key={item._id}>
                  <TableCell>{(page - 1) * limit + index + 1}</TableCell>
                  <TableCell>{item?.data?.name || "-"}</TableCell>
                  <TableCell>{item?.data?.email || "-"}</TableCell>
                  <TableCell>{`+${item?.data?.phone}` || "-"}</TableCell>
                  <TableCell>{`${item?.data?.applicationType}` || "-"}</TableCell>
                  <TableCell>{`${item?.data?.application_name || "-"}` || "-"}</TableCell>
                  <TableCell>
                    {item.createdAt ? dayjs(item.createdAt).format("DD/MM/YYYY") : "-"}
                  </TableCell>
                  
                  {/* Actions */}
                  <TableCell>
                    <IconButton
                      onClick={() => {
                        setSelectedApp(item);
                        setOpenModal(true);
                      }}
                      title="View Details"
                    >
                      👁️
                    </IconButton>
                    <IconButton
                      onClick={() => {
                        setDeleteItem({
                          title: item.data?.title?.en,
                          id: item._id,
                        });
                        setOpen(true);
                      }}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={8} align="center">
                  <Typography variant="body2" color="textSecondary">
                    No applications found
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <ConsultationModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        application={selectedApp}
      />

      {/* Pagination */}
      {totalPages > 1 && (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 2, gap: 2 }}>
          <Button
            variant="outlined"
            disabled={page === 1}
            onClick={() => setPage(page - 1)}
          >
            Prev
          </Button>
          <Button
            variant="outlined"
            disabled={page === totalPages}
            onClick={() => setPage(page + 1)}
          >
            Next
          </Button>
        </Box>
      )}
    </Admin>
  );
}